/**
 * Blue Zone — toast copy (NL/EN). Keys match bz-toast showKey().
 * Sync: shared_head.liquid, assets/bz-toast-locales.js
 */
window.bzToastLocales = {
  nl: {
    photo_saved: 'Foto opgeslagen',
    photo_upload_failed: 'Upload mislukt',
    photo_too_large: 'Afbeelding is te groot (max 15 MB)',
    photo_profile_not_loaded: 'Hondprofiel niet geladen',
    photo_upload_unavailable: 'Foto kan nu niet worden geüpload. Probeer het opnieuw.',
    skip_email_error:
      'Er ging iets mis. Probeer het opnieuw of vul je e-mailadres in.',
    invalid_pet_data: 'Er is een fout opgetreden. Probeer de pagina te vernieuwen.',
    account_creation_error:
      'Er is een fout opgetreden bij het aanmaken van je account. Probeer het opnieuw.',
    cart_checkout_error:
      'Er ging iets mis bij het toevoegen aan je winkelwagen. Probeer het opnieuw.',
    resume_one_prefix: 'Je hebt al een profiel voor ',
    resume_one_link: 'Ga verder waar je was gebleven',
    resume_multi_prefix: 'Je hebt al profielen voor: ',
    resume_multi_link: 'Bekijk je profielen',
    profile_saved: 'Profiel van {name} is opgeslagen',
    profile_removed: 'Profiel van {name} is verwijderd',
    dog_removed: '{name} is verwijderd',
    order_summary_error:
      'We konden je besteloverzicht nu niet laden. Probeer het later opnieuw.',
    date_changed: 'Je volgende zending staat op {date}',
    frequency_changed: 'Je ontvangt nu elke {days} dagen een box',
    date_no_order: 'Er is geen geplande zending die je kunt aanpassen.',
    plan_updated: 'Je plan is bijgewerkt',
    plan_update_error: 'We konden je plan niet bijwerken. Probeer het opnieuw.',
    product_added_plan: 'Toegevoegd aan je plan',
    product_added_next: 'Toegevoegd aan je volgende zending',
    link_copied: 'Link gekopieerd!',
    instagram_fallback: 'Link gekopieerd — plak in Instagram om te delen.',
    copy_error: 'Kon de link niet kopiëren. Probeer het opnieuw.',
    referral_load_error: 'Kon je referralgegevens niet laden. Probeer het later opnieuw.',
    pause_success: 'Je plan is gepauzeerd. Leveringen hervatten rond {date}',
    skip_success: 'Je levering is overgeslagen. Volgende levering rond {date}',
    discount_applied: 'Korting toegepast op je volgende levering',
    discount_apply_error: 'We konden de korting niet toepassen. Probeer het opnieuw.',
    cancel_action_error: 'We konden je verzoek niet verwerken. Probeer het opnieuw.',
    close: 'Sluiten',
  },
  en: {
    photo_saved: 'Photo saved',
    photo_upload_failed: 'Upload failed',
    photo_too_large: 'Image is too large (max 15 MB)',
    photo_profile_not_loaded: 'Pet profile not loaded',
    photo_upload_unavailable: 'Unable to upload photo right now. Please try again.',
    skip_email_error: 'Something went wrong. Please try again or enter your email address.',
    invalid_pet_data: 'Something went wrong. Please refresh the page and try again.',
    account_creation_error: 'Something went wrong while creating your account. Please try again.',
    cart_checkout_error: 'Something went wrong adding to your cart. Please try again.',
    resume_one_prefix: 'You already have a profile for ',
    resume_one_link: 'Continue where you left off',
    resume_multi_prefix: 'You already have profiles for: ',
    resume_multi_link: 'View your profiles',
    profile_saved: "{name}'s profile has been saved",
    profile_removed: "{name}'s profile has been removed",
    dog_removed: '{name} has been removed',
    order_summary_error:
      'We could not load your order summary right now. Please try again later.',
    date_changed: 'Your next shipment is scheduled for {date}',
    frequency_changed: "You'll now receive a box every {days} days",
    date_no_order: 'There is no scheduled shipment you can change.',
    plan_updated: 'Your plan has been updated',
    plan_update_error: "We couldn't update your plan. Please try again.",
    product_added_plan: 'Added to your plan',
    product_added_next: 'Added to your next shipment',
    link_copied: 'Link copied!',
    instagram_fallback: 'Link copied — paste in Instagram to share.',
    copy_error: 'Could not copy the link. Please try again.',
    referral_load_error: 'Could not load your referral details. Please try again later.',
    pause_success: 'Your plan has been paused. Shipments resume around {date}',
    skip_success: 'Your shipment has been skipped. Next shipment around {date}',
    discount_applied: 'Discount applied to your next shipment',
    discount_apply_error: "We couldn't apply the discount. Please try again.",
    cancel_action_error: "We couldn't process your request. Please try again.",
    close: 'Close',
  },
};
